import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 15px;
  header {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
    margin: 0 auto;
  }
  button {
    width: 15rem;
    margin: 0 auto;
  }
  > div {
    &:first-of-type {
      white-space: pre-line;
      text-align: center;
      margin-top: auto;
    }
    &:nth-of-type(2) {
      font-style: italic;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: auto;
      margin-bottom: 3rem;
    }

    &:last-of-type {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
    }
  }
`;

// Criado scroll para evitar que o botão fique oculto em telas de smartphones
export const Scroll = styled(PerfectScrollbar)`
  height: calc(100vh - 260px);
  // Estilizado header para destacar a diferença pro texto da locução
  header {
    text-align: center;
    margin: 2rem 0;
    padding-bottom: 2rem;
    font-style: bold;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
  }
`;
